const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  email: 'Email',
  otp: 'Email',
  google: 'Google',
  apple: 'Apple',
  x: 'X',
  wallet: 'Wallet',
  passkey: 'Passkey',
};

export function getProviderDisplayName(provider: string): string {
  return PROVIDER_DISPLAY_NAMES[provider] ?? provider;
}
